import type {
  ContentHomeAboutQueryVariables,
  ContentHomeInfoQueryVariables,
  ContentHomeNoticeQueryVariables,
  ContentHomeOverviewQueryVariables,
  ContentHomeProductListQueryVariables,
  ContentHomeRecommendQueryVariables,
  ContentProductCursorIndexQueryVariables,
  ContentSetListQueryVariables,
  ContentSetOverviewQueryVariables,
  SimpleSeriesSingleInfoQueryVariables,
} from '../../graphql/generated/types';
import {ADAPTER_QUERY_KEY_PREFIX} from '../constant';

/**
 * Content 도메인 Query Key 관리
 */
export const CONTENT_QUERY_KEY_MAP = {
  /**
   * 콘텐츠 홈 소개 정보 조회
   * Origin: useContentHomeAboutQuery.getKey
   */
  contentHomeAbout: (variables: ContentHomeAboutQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'contentHomeAbout', variables] as const,
  /**
   * 콘텐츠 홈 정보 조회 (about + recommend)
   * Origin: useContentHomeInfoQuery.getKey
   */
  contentHomeInfo: (variables: ContentHomeInfoQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'contentHomeInfo', variables] as const,
  /**
   * 콘텐츠 홈 공지사항 조회
   * Origin: useContentHomeNoticeQuery.getKey
   */
  contentHomeNotice: (variables: ContentHomeNoticeQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'contentHomeNotice', variables] as const,
  /**
   * 콘텐츠 홈 공지사항 조회 (Infinite)
   * Origin: useInfiniteContentHomeNoticeQuery.getKey
   */
  infiniteContentHomeNotice: (variables: ContentHomeNoticeQueryVariables) =>
    [
      ADAPTER_QUERY_KEY_PREFIX,
      'contentHomeNotice.infinite',
      variables,
    ] as const,
  /**
   * 콘텐츠 홈 개요 정보 조회
   * Origin: useContentHomeOverviewQuery.getKey
   */
  contentHomeOverview: (variables: ContentHomeOverviewQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'contentHomeOverview', variables] as const,
  /**
   * 콘텐츠 홈 작품 목록 조회
   * Origin: useContentHomeProductListQuery.getKey
   */
  contentHomeProductList: (variables: ContentHomeProductListQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'contentHomeProductList', variables] as const,
  /**
   * 콘텐츠 홈 작품 목록 조회 (Infinite)
   * Origin: useInfiniteContentHomeProductListQuery.getKey
   */
  infiniteContentHomeProductList: (
    variables: ContentHomeProductListQueryVariables
  ) =>
    [
      ADAPTER_QUERY_KEY_PREFIX,
      'contentHomeProductList.infinite',
      variables,
    ] as const,
  /**
   * 콘텐츠 홈 추천 정보 조회
   * Origin: useContentHomeRecommendQuery.getKey
   */
  contentHomeRecommend: (variables: ContentHomeRecommendQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'contentHomeRecommend', variables] as const,
  /**
   * 콘텐츠 작품 커서 인덱스 조회
   * Origin: useContentProductCursorIndexQuery.getKey
   */
  contentProductCursorIndex: (
    variables: ContentProductCursorIndexQueryVariables
  ) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'contentProductCursorIndex', variables] as const,
  /**
   * 콘텐츠 세트 목록 조회
   * Origin: useContentSetListQuery.getKey
   */
  contentSetList: (variables: ContentSetListQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'contentSetList', variables] as const,
  /**
   * 콘텐츠 세트 개요 조회
   * Origin: useContentSetOverviewQuery.getKey
   */
  contentSetOverview: (variables: ContentSetOverviewQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'contentSetOverview', variables] as const,
  /**
   * 콘텐츠 단일 회차 기본 정보 조회
   * Origin: useSimpleSeriesSingleInfoQuery.getKey
   */
  simpleSeriesSingleInfo: (variables: SimpleSeriesSingleInfoQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'simpleSeriesSingleInfo', variables] as const,
} as const;
